<template>
	<v-dialog :value="value" max-width="600" @input="$emit('input', $event)">
		<v-card>
			<v-card-title>Importa {{ quanti }} {{ quanti === 1 ? 'prodotto' : 'prodotti' }} nel catalogo</v-card-title>
			<v-card-text class="text-left">
				<v-alert v-if="errore" type="error" dense outlined>{{ errore }}</v-alert>
				<v-alert v-if="filtro" type="info" dense text>
					Si importano tutti i prodotti che la lista mostra con i filtri attuali<span v-if="filtro.q"> (ricerca «{{ filtro.q }}»)</span>.
					<span v-if="quanti > massimo"> Per volta se ne importano {{ massimo }}: al termine ripeti per i restanti.</span>
				</v-alert>
				<p>
					I prodotti vengono creati <strong>disattivi</strong>, con giacenza 0 e il prezzo trovato sul sito della marca come prezzo al pubblico: controllali prima di pubblicarli. Solo ora le immagini vengono copiate su S3.
				</p>
				<p class="caption">I prodotti senza SKU sul sito della marca ricevono lo SKU come con «Genera SKU automatici», l'EAN resta vuoto e, senza prezzo, il prezzo è 0: si completano dalla scheda prodotto.</p>
				<v-alert v-if="sottoCento" type="warning" dense text>
					{{ sottoCento === 1 ? 'Un prodotto non ha' : `${sottoCento} prodotti non hanno` }} i testi a 100/100: puoi importare lo stesso, ma conviene usare «Riscrivi testi» e controllare la sezione SEO della scheda.
				</v-alert>
				<p class="caption">Il punteggio finale in catalogo dipende anche da prezzo, EAN e numero di immagini.</p>
				<p class="caption">I prodotti «Da tradurre» entrano con il testo nella lingua della pagina originale: traducili prima con «Traduci».</p>
				<v-autocomplete v-model="categorie" :items="opzioni.categories" item-text="name" item-value="_id" label="Categorie" multiple chips small-chips deletable-chips outlined dense></v-autocomplete>
				<v-select v-model="iva" :items="opzioni.vat" item-text="vat" item-value="vat" label="Aliquota IVA" suffix="%" outlined dense :rules="[v => v !== null && v !== undefined || 'Obbligatoria']"></v-select>
				<v-checkbox v-model="duplicati" dense hide-details label="Importa anche i prodotti con EAN/SKU già presenti in catalogo"></v-checkbox>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text @click="$emit('input', false)">Annulla</v-btn>
				<v-btn color="primary" depressed :loading="invio" :disabled="iva === null || iva === undefined" @click="conferma">Importa</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { testoErrore } from './testi';

export default {
	name: 'BrandImportApproveDialog',
	props: {
		value: { type: Boolean, default: false },
		ids: { type: Array, default: () => [] },
		brandId: { type: String, default: null },
		// "Importa tutti quelli filtrati": filtri della lista ({ status, q, duplicates }) e quanti sono
		filtro: { type: Object, default: null },
		totale: { type: Number, default: 0 },
	},
	data() {
		return { opzioni: { categories: [], vat: [] }, categorie: [], iva: null, duplicati: false, invio: false, errore: '', massimo: 500, sottoCento: 0 };
	},
	computed: {
		quanti() {
			return this.filtro ? this.totale : this.ids.length;
		},
	},
	watch: {
		async value(aperto) {
			if (!aperto) return;
			this.errore = '';
			this.sottoCento = 0;
			// avviso, non blocco: con "importa tutti i filtrati" gli id non si conoscono e resta la nota generale
			if (this.ids.length && !this.filtro) {
				const conteggio = await this.$store.dispatch('brandimport/seoSummary', { ids: this.ids });
				if (!conteggio.error && conteggio.data) this.sottoCento = conteggio.data.sottoCento;
			}
			if (this.opzioni.vat.length) return;
			const res = await this.$store.dispatch('brandimport/fetchOptions');
			if (res.error) {
				this.errore = testoErrore(res.error);
				return;
			}
			this.opzioni = res.data;
			const def = res.data.vat.find(v => v.default) || res.data.vat[0];
			this.iva = def ? def.vat : null;
		},
	},
	methods: {
		async conferma() {
			this.invio = true;
			const comuni = { brandId: this.brandId, vat: this.iva, categories: this.categorie, allowDuplicates: this.duplicati };
			const res = this.filtro
				? await this.$store.dispatch('brandimport/approveFiltered', { ...comuni, filter: this.filtro })
				: await this.$store.dispatch('brandimport/approveProducts', { ...comuni, ids: this.ids });
			this.invio = false;
			if (res.error) {
				this.errore = testoErrore(res.error);
				return;
			}
			this.$emit('done', res.data);
			this.$emit('input', false);
		},
	},
};
</script>
